<!-- TEMPLATE -->
<template>
  <div class="dashboard">
    <div class="row">
      <zoom-y-transition>
        <perfect-scrollbar
                :options="{suppressScrollX:true}"
                v-show="!$store.getters.getLoadOverlay"
                class="small-12 medium-12 large-12 hd-12 columns dashboard-content"
        >
          <router-view key="xxxxx"></router-view>
        </perfect-scrollbar>
      </zoom-y-transition>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Provide, Watch } from 'vue-property-decorator';
  import { ZoomYTransition, ZoomCenterTransition } from 'vue2-transitions';

  import {
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanSidemenu,
    deanLoadOverlay,
    invoicesIcon,
    commissionIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanSidemenu,
      deanLoadOverlay,
      invoicesIcon,
      commissionIcon,
      ZoomYTransition,
    },
  })

  export default class Dashboard extends Vue {
    // DATA
    public sidemenu: object = {
      content: {
        title: {
          text: 'Dashboard',
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        icon: invoicesIcon,
        sections: {
          general: {
            title: 'General',
            items: {},
          },
        },
      },
    };

    // METHODS
    public deanSidemenuRoute(item: any) {
      this.$router.push(item.url);
    }

  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  @import '~@deanone/dean-components/src/scss/vars';

  .dashboard,
  .dashboard-content {
    background: #f4f4f4;
    @include calc(min-height, "100vh - 80px");
  }

  .dashboard-title {
    text-transform: lowercase;
  }

  .ps {
    height: calc(100vh - 80px);
  }

</style>
